import coreAPI from 'apis/core';

export const getUnreadClinicMessages = async (clinicId) => {
  return coreAPI.clinic.getClinicMessages({ clinicId, status: 'unread' });
};

export const getClinicMessageStats = async (clinicId) => {
  return coreAPI.clinic.getClinicMessageStats({ clinicId });
};

export default {};
